// Every enum the partner API defines, transcribed from the docs (§7 for
// partners/complaints, §9 for to-dos, §10 for attendance, §11 for payroll).
// Pages import these rather than spelling values inline, so a vocabulary can
// never drift between the filter dropdown and the table that renders it.

/* --- partners & employees (§7) ------------------------------------------ */
export const ACCOUNT_STATUSES = ["ACTIVE", "INACTIVE", "SUSPENDED"];
export const BUSINESS_TYPES = ["CINEMA", "CAFE", "RESTAURANT"];

/* --- complaints (§7) ----------------------------------------------------- */
export const COMPLAINT_STATUSES = [
  "OPEN",
  "ASSIGNED",
  "UNDER_REVIEW",
  "HOLD",
  "RESOLVED",
  "REOPENED",
];
export const COMPLAINT_PRIORITIES = ["LOW", "MEDIUM", "HIGH", "URGENT"];

/* --- to-dos (§9) --------------------------------------------------------- */
// A task is only ever ACTIVE or PAUSED. Whether it is *done* is not a field on
// the task at all — it is a per-day completion record (see api/todos.js).
export const TODO_STATUSES = ["ACTIVE", "PAUSED"];
export const TODO_PRIORITIES = ["LOW", "MEDIUM", "HIGH", "URGENT"];
export const TODO_COMPLETION_STATUSES = ["DONE", "PENDING"];

/* --- attendance (§10) ---------------------------------------------------- */
export const ATTENDANCE_STATUSES = [
  "PRESENT",
  "HALF_DAY",
  "ABSENT",
  "LEAVE",
  "HOLIDAY",
  "WEEK_OFF",
];

// Where a punch came from: the employee's own device, or a panel correction.
export const PUNCH_SOURCES = ["EMPLOYEE", "PARTNER", "ADMIN"];

/* --- payroll (§11) ------------------------------------------------------- */
export const PAYROLL_STATUSES = ["PENDING", "PARTIALLY_PAID", "PAID"];
export const PAYMENT_MODES = ["CASH", "BANK_TRANSFER", "UPI", "CHEQUE", "OTHER"];

/* --- work profile (§12) -------------------------------------------------- */
// Weekday numbers as the API uses them: 0 = Sunday ... 6 = Saturday.
export const WEEKDAYS = [
  { value: 0, label: "Sun" },
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
];

// What the API itself defaults to when timings are set without a day list.
export const DEFAULT_WORKING_DAYS = [1, 2, 3, 4, 5, 6];

/* --- display helpers ----------------------------------------------------- */

// Tailwind classes per status. Kept beside the enums so a new value can never
// be added to one without the other being obvious.
export const ATTENDANCE_STATUS_STYLES = {
  PRESENT: "bg-emerald-100 text-emerald-800",
  HALF_DAY: "bg-amber-100 text-amber-800",
  ABSENT: "bg-red-100 text-red-700",
  LEAVE: "bg-purple-100 text-purple-800",
  HOLIDAY: "bg-blue-100 text-blue-800",
  WEEK_OFF: "bg-gray-100 text-gray-600",
};

export const PAYROLL_STATUS_STYLES = {
  PENDING: "bg-amber-100 text-amber-800",
  PARTIALLY_PAID: "bg-blue-100 text-blue-800",
  PAID: "bg-emerald-100 text-emerald-800",
};

export const TODO_STATUS_STYLES = {
  ACTIVE: "bg-emerald-100 text-emerald-800",
  PAUSED: "bg-gray-100 text-gray-600",
};

// Human labels where the raw enum reads badly.
export const ATTENDANCE_STATUS_LABELS = {
  PRESENT: "Present",
  HALF_DAY: "Half day",
  ABSENT: "Absent",
  LEAVE: "Leave",
  HOLIDAY: "Holiday",
  WEEK_OFF: "Week off",
};

export const PAYROLL_STATUS_LABELS = {
  PENDING: "Pending",
  PARTIALLY_PAID: "Partially paid",
  PAID: "Paid",
};

export const PAYMENT_MODE_LABELS = {
  CASH: "Cash",
  BANK_TRANSFER: "Bank transfer",
  UPI: "UPI",
  CHEQUE: "Cheque",
  OTHER: "Other",
};
